import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://www.hemeantto.com";
const DEFAULT_IMAGE =
  "https://images.pexels.com/photos/6474471/pexels-photo-6474471.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=630&w=1200";

// SEO — sets per-page <title>, meta description, canonical, hreflang alternates,
// Open Graph and Twitter Card tags. Path should start with "/".
export default function SEO({
  title,
  description,
  path = "/",
  lang = "en",
  image = DEFAULT_IMAGE,
  noindex = false,
}) {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  const url = `${SITE}${cleanPath}`;
  const urlEn = `${SITE}${cleanPath}${cleanPath.includes("?") ? "&" : "?"}lang=en`;
  const urlEs = `${SITE}${cleanPath}${cleanPath.includes("?") ? "&" : "?"}lang=es`;
  const ogLocale = lang === "es" ? "es_US" : "en_US";
  const altLocale = lang === "es" ? "en_US" : "es_US";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex ? (
        <meta name="robots" content="noindex, follow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      )}
      <link rel="canonical" href={url} />

      {/* hreflang */}
      <link rel="alternate" hrefLang="en-US" href={urlEn} />
      <link rel="alternate" hrefLang="es-US" href={urlEs} />
      <link rel="alternate" hrefLang="x-default" href={url} />

      {/* Open Graph */}
      <meta property="og:site_name" content="He Meant To" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:locale:alternate" content={altLocale} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
